import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers, Enums } from "@shared";
import { useSpinnerContext } from '@contexts';
import { sunboundPayProxy } from '@proxies';
import currency from "currency.js";
import { useAllowedPaymentTypes } from "../hooks/useAllowedPaymentTypes/useAllowedPaymentTypes";

const AutoPayConfirmation = () => {

    const navigate = useNavigate(), location = useLocation();
    const { setSpinnerShow } = useSpinnerContext();
    const [error, setError] = useState(``);
    const { allowedPaymentTypes } = useAllowedPaymentTypes();
    const {
        state: {
            currentBill: { invitations },
            account: {
                paymentPreferences: { defaultPaymentMethod },
                accountPreferences: { paymentTypeFees, dueDay },
                idAccount,
                idPayor
            }
        } } = location;

    const payorInvitation = invitations.find(i => i.idPayor === idPayor);
    const { balance } = payorInvitation;

    const { idPaymentType, sourceName, last4 } = defaultPaymentMethod;
    const ptFeeRule = paymentTypeFees.find(f => f.idPaymentType === idPaymentType);
    
    const paymentMethodIsAllowed = allowedPaymentTypes.includes(idPaymentType);

    let ptfee;
    if (ptFeeRule.idFeeType === Enums.FeeType.Fixed)
        ptfee = currency(ptFeeRule.fee);
    else
        ptfee = currency(ptFeeRule.fee, { precision: 3 }).multiply(balance);

    const total = currency(balance).add(ptfee);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const save = async () => {
        if (!paymentMethodIsAllowed) {
            setError(`Payment type is invalid. Please select another payment method`);
            return;
        }
        setSpinnerShow(true);
        try {
            await sunboundPayProxy.updateAccountPayorPreferences(idAccount, { isAutoPay: true, dueDay });
            helpers.navigateNext(location, navigate, { makePayment: false });
        } catch (error) {
            console.log(error);
        }
        setSpinnerShow(false);
    };

    return (
        <div className="flex flex-col bg-white p-6 w-full rounded-b-lg gap-y-5 min-h-sb pb-12 items-center">
            <h1 className="text-center font-bold text-2xl">Turn On Auto-Pay</h1>
            <div className="flex flex-col items-left p-4 gap-y-4">
                <span>
                    By clicking <b>Save Changes</b> you are authorizing Sunbound to debit your account for your total monthly balance on your payment date
                </span>
                <div className="grid grid-cols-2 w-full px-5 py-2 gap-y-2 rounded-lg border-2 shadow-md bg-sb-frame">
                    <div>Payment Day</div>
                    <div className="text-right font-bold">{`On the ${helpers.dayOrdinal(dueDay)}`}</div>
                    <div>Payment Method</div>
                    <div className="text-right font-bold">{`${sourceName} ****${last4}`}</div>
                    <div>Subtotal</div>
                    <div className="text-right font-bold">{currency(balance).format()}</div>
                    <div>Processing Fee</div>
                    <div className="text-right  font-bold">{currency(ptfee, { precision: 2 }).format()}</div>
                    <div className="font-bold">Total</div>
                    <div className="font-bold text-right">{total.format()}</div>
                </div>
                <span>
                    Your full balance will be paid on your chosen payment date. You are still free to make payments before that date.
                </span>
                <button type="button" className="btn btn-primary text-xl mt-3 rounded-full" onClick={save}>Save Changes</button>
                {!!error && (
                    <div className="w-full">
                        <span className="text-red-400 font-semibold">{error}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AutoPayConfirmation;
